export const calculatePercentage = (partial, total) => {
	return (partial / total) * 100;
};
